import { LocaleLanguageCode, Locations } from 'Constants/Common';
import { ApiHelper } from './apiHelper';

export class TitleApi {
    async getTitlesAsync(
        token: string,
        successCallback: (titles: string[]) => void,
        failureCallback: (error: string) => void,
        signal: AbortSignal,
        language: string
    ): Promise<void> {
        let url = '/api/title/title?language=';

        switch (language) {
            case Locations.De:
                url += LocaleLanguageCode.DE;
                break;
            case Locations.At:
                url += LocaleLanguageCode.AT;
                break;
            default:
                url += LocaleLanguageCode.GB;
        }

        await new ApiHelper().getDataSecureAsync(
            url,
            token,
            successCallback,
            failureCallback,
            signal
        );
    }
}
